import CompanyStateLocation from "entities/UIModel/company/CompanyStateLocation";

const mapUiCompanyStateLocation = (data: any): CompanyStateLocation[] => {
  if (!data?.length) return [];

  const locations = data.map((l: any) => {
    const location: CompanyStateLocation = {
      contractID: l.contractID,
      companyID: l.companyID,
      legacyID: l.legacyID,

      locationID: l.locationID,
      locationUniqueID: l.locationUniqueID,
      locationDisplayName: l.locationDisplayName,
      locationLegalName: l.locationLegalName,
      locationLegacyID: l.locationLegacyID,

      locationAddress: l.locationAddress,
      locationAddress2: l.locationAddress2,
      locationCity: l.locationCity,
      locationState: l.locationState,
      locationZipCode: l.locationZipCode,
      locationCountry: l.locationCountry,
      locationMainPhone: l.locationMainPhone,
      locationMobilePhone: l.locationMobilePhone,
      locationFaxNumber: l.locationFaxNumber,
      locationPrimaryEmail: l.locationPrimaryEmail,

      altaRegistryID: l.altaRegistryID,
      territoryID: l.territoryID,

      authorityLimit: l.authorityLimit,
      underwriterTypeCode: l.underwriterTypeCode,
    };
    return location;

  });

  return locations;
}

export {
  mapUiCompanyStateLocation,
}